import { Box, Stack } from "@mui/material"
import Controls from "./controls/Controls"
import { useState } from "react"
import DeleteIcon from "@mui/icons-material/Delete"
import SaveIcon from "@mui/icons-material/Save"
import { useSnackbar } from "notistack"
import db from "../Firestore"
import * as dataServices from "../pages/services/dataServices"
import { useEffect } from "react"
import firebase from "firebase/compat/app"
import { useHistory, withRouter } from "react-router-dom"
import { spacing } from "../pages/services/styleServices"
import ArchiMateElementSelect from "./controls/ArchiMateElementSelect"
import * as palette from "./symbols/palette"
import TiptapEditor from "./tiptap/Tiptap"
import { markdownToTiptapJSON } from "./tiptap/markdownConverter"
import useConfirmationDialog from "./useConfirmationDialog"

const styles = {
  fab: {
    position: "fixed",
    bottom: 16,
    right: 16,
    top: "auto",
    left: "auto",
  },

  buttons: {
    marginTop: spacing(3),
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "5px",
  },
}

const ElementPromptEditForm = (props) => {
  const [elementId, setElementId] = useState(props.computedMatch.params.id)

  const { enqueueSnackbar } = useSnackbar()

  const history = useHistory()

  const { ConfirmationDialog, confirm } = useConfirmationDialog()

  const [fieldErrors, setFieldErrors] = useState({})

  const [values, setValues] = useState({
    account_id: "",
    name: "",
    prompt: "",
    type: "",
    created: dataServices.localTimestamp(),
    modified: dataServices.localTimestamp(),
  })

  useEffect(() => {
    if (elementId) {
      db.collection("elements")
        .doc(elementId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            const data = doc.data()

            const newValues = {
              ...data,
              type: palette.getElementType(data.type).index,
            }

            setValues(newValues)
          } else {
            enqueueSnackbar("Prompt not found", { variant: "error" })
          }
        })
        .catch((error) => {
          enqueueSnackbar("Error getting prompt", { variant: "error" })
        })
    }
  }, [elementId])

  const isNew = () => elementId === undefined || elementId === ""

  const handleDeletePrompt = async () => {
    const confirmed = await confirm({
      title: "Delete Element?",
      description: "This delete is permanent. Are you sure?",
      yesText: "Delete",
      yesColor: "error",
      noText: "Cancel",
    })

    if (!confirmed) {
      return
    }

    if (elementId !== undefined && elementId !== "" && elementId !== null) {
      db.collection("elements")
        .doc(elementId)
        .delete()
        .then(history.push("/elementprompts"))
        .then(() => {
          enqueueSnackbar("Deleted", { variant: "success" })
        })
    }
  }

  const handleSave = async (event) => {
    event.preventDefault()

    const newFieldErrors = {}

    if (values.name === "") {
      newFieldErrors.name = "Enter a name"
    }
    if (values.prompt === "") {
      newFieldErrors.prompt = "Enter a prompt"
    }

    if (values.type === "") {
      newFieldErrors.type = "Select element type"
    }

    setFieldErrors(newFieldErrors)

    if (Object.keys(newFieldErrors).length === 0) {
      if (isNew()) {
        firebase
          .auth()
          .currentUser.getIdTokenResult()
          .then(async (token) => {
            const newElement = {
              ...values,
              type: palette.getElementNameByIndex(values.type),
              account_id: token.claims.account_id,
              created: dataServices.serverTimestamp(),
              modified: dataServices.serverTimestamp(),
            }

            await db
              .collection("elements")
              .add(newElement)
              .then((docRef) => {
                setElementId(docRef.id)
                history.replace(`/elementprompt/${docRef.id}`)
              })
              .then(() => {
                enqueueSnackbar("Created", {
                  variant: "success",
                })
              })
          })
          .catch(function (error) {
            console.error("Error:" + error)
          })
      } else {
        const updateRecord = {
          ...values,
          type: palette.getElementNameByIndex(values.type),
          modified: dataServices.serverTimestamp(),
        }

        db.collection("elements")
          .doc(elementId)
          .update(updateRecord)
          .then(() => {
            enqueueSnackbar("Element saved", {
              variant: "success",
              vertical: "bottom",
              horizontal: "right",
            })
          })
      }
    }
  }

  return (
    <>
      <ConfirmationDialog />

      <Box sx={{ width: "600px" }}>
        <Stack
          direction="column"
          spacing={1}
          sx={{ marginTop: "20px", gap: 2 }}
        >
          <Controls.TextInput
            label="Name"
            value={values.name}
            onChange={(e) => setValues({ ...values, name: e.target.value })}
            sx={{ width: "100%" }}
            error={Boolean(fieldErrors.name)}
            helperText={fieldErrors.name}
          />

          <ArchiMateElementSelect
            label="Type"
            type={values.type}
            error={fieldErrors.type}
            setType={(newType) => {
              setValues((curr) => {
                const newValues = {
                  ...curr,
                  type: newType,
                }
                const typeDef = palette.getElementTypeByIndex(newType)
                console.log("typeDef", typeDef)
                newValues.name = palette.formatLabel(typeDef.name)
                newValues.prompt = typeDef.label
                return newValues
              })
            }}
            sx={{ width: "100%" }}
          />

          <TiptapEditor
            content={markdownToTiptapJSON(values.prompt)}
            onUpdate={(value) => setValues({ ...values, prompt: value })}
          />
        </Stack>

        <Box sx={styles.buttons}>
          {!isNew() && (
            <Controls.Button
              text="Delete"
              type="button"
              tooltip="Delete this element"
              endIcon={<DeleteIcon />}
              onClick={handleDeletePrompt}
            />
          )}

          <Controls.Button
            type="button"
            text="Save"
            tooltip="Save element"
            variant="contained"
            endIcon={<SaveIcon />}
            onClick={(event) => handleSave(event)}
          />
        </Box>
      </Box>
    </>
  )
}

export default withRouter(ElementPromptEditForm)
